'use strict';

const LABEL_STORAGE_KEYS = {
    mid: 'kleep_mid',
    cid: 'kleep_cid',
    uid: 'kleep_uid'
};

const kleepTrackingEndpoints = {
    productViewed: $('.js-kleep-tracking-product-viewed').val(),
    addToCart: $('.js-kleep-tracking-add-to-cart').val(),
    checkoutCompleted: $('.js-kleep-tracking-checkout-completed').val(),
    checkoutValidated: $('.js-kleep-tracking-checkout-validated').val(),
    buttonClicked: $('.js-kleep-tracking-button-clicked').val()
};

let productAddedToCartData = {};

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

async function sendTrackingData(endpoint, trackingData) {
    try {
        trackingData.uid = localStorage.getItem(LABEL_STORAGE_KEYS.uid);
        trackingData.mid = localStorage.getItem(LABEL_STORAGE_KEYS.mid);

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {'Content-Type': 'application/json; charset=utf-8'},
            body: JSON.stringify(trackingData)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error(`[Kleep] Error in sendTrackingData at endpoint ${endpoint}: `, error);
        throw error;
    }
}

async function sendTrackingDataProductViewed(pid) {
    const kleepTrackingData = {
        pid: pid
    };

    return sendTrackingData(kleepTrackingEndpoints.productViewed, kleepTrackingData);
}

async function sendTrackingDataButtonClicked(pid) {
    const kleepTrackingData = {
        pid: pid
    };

    return sendTrackingData(kleepTrackingEndpoints.buttonClicked, kleepTrackingData);
}

async function sendTrackingDataAddToCart() {
    return sendTrackingData(kleepTrackingEndpoints.addToCart, productAddedToCartData);
}

async function sendTrackingDataCheckoutCompleted(orderNo) {
    const kleepTrackingData = {
        orderNo: orderNo
    };

    return sendTrackingData(kleepTrackingEndpoints.checkoutCompleted, kleepTrackingData);
}

async function sendTrackingDataCheckoutValidated() {
    return sendTrackingData(kleepTrackingEndpoints.checkoutValidated, {});
}

function handleError(context, error) {
    console.error(`[Kleep] Failed to send tracking data on ${context}: `, error);
}

function initProductViewedTracking() {
    const $addToCart = $('.button.add-to-cart, .button.add-to-cart-global').first();
    const currentPid = getPidValue($addToCart);

    if (currentPid) {
        sendTrackingDataProductViewed(currentPid).catch(error => handleError('productViewed', error));
    }

    $('body').on('product:updateAvailability', function (e, response) {
        if (response.product && response.product.id) {
            sendTrackingDataProductViewed(response.product.id).catch(error => handleError('update availability', error));
        }
    });
}

function initButtonClickedTracking() {
    $('body').on('click', '.kleep-button', () => {
        const $addToCart = $('.button.add-to-cart, .button.add-to-cart-global').first();
        const currentPid = getPidValue($addToCart);

        if (currentPid) {
            sendTrackingDataButtonClicked(currentPid).catch(error => handleError('buttonClicked', error));
        }
    });
}

function initAddToCartTracking() {
    $('body').on('updateAddToCartFormData', function (e, response) {
        // productAddedToCartData used to transfer data to the product:afterAddToCart event
        productAddedToCartData = response;
    });
    $('body').on('product:afterAddToCart', function () {
        sendTrackingDataAddToCart().catch(error => handleError('updateAddToCartFormData', error));
        productAddedToCartData = {};
    });
}

function initCheckoutCompletedTracking() {
    const orderNo = $('.js-tracking-order-no').val();

    if (orderNo) {
        sendTrackingDataCheckoutCompleted(orderNo).catch(error => handleError('checkoutCompleted', error));
    }
}

function initCheckoutValidatedTracking() {
    const checkoutMain = document.querySelector('#checkout-main');

    if (checkoutMain) {
        if (checkoutMain.getAttribute('data-checkout-stage') === 'placeOrder') {
            sendTrackingDataCheckoutValidated().catch(error => handleError('checkoutValidated', error));
        }

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-checkout-stage') {
                    if (checkoutMain.getAttribute('data-checkout-stage') === 'placeOrder') {
                        sendTrackingDataCheckoutValidated().catch(error => handleError('checkoutValidated', error));
                    }
                }
            });
        });

        observer.observe(checkoutMain, { attributes: true, attributeFilter: ['data-checkout-stage'] });
    }
}

$(document).ready(function () {
    initProductViewedTracking();
    initAddToCartTracking();
    initCheckoutCompletedTracking();
    initCheckoutValidatedTracking();
    initButtonClickedTracking();
});